<template>
      <!-- <div class="task-page-header white-bg">
  <span class="tooltip-wrapper" @click="onclosed">
    <i class="fa fa-times close-icon"></i>
  </span>
</div> -->
<div class="row wrapper border-bottom white-bg page-heading">
    <!-- Title on the left -->
    <div class="col-lg-12 d-flex justify-content-end">
      <a @click="onclosed">
    <i class="fa fa-times close-icon"></i>
      </a>
    </div>
  </div>

  <div class="row g-2">
    <!-- LEFT PANEL -->
    <div class="col-md-4">
      <div class="ibox mt-2">
        <div class="ibox-title bg-light py-2">
          <h5 class="mb-0">Task List</h5>
        </div>

        <div class="ibox-content p-2">
           <!-- NO DATA -->
         <div v-if="!tasks || tasks.length === 0" class="text-center text-muted py-2">
            No data found
          </div>

          <ul  class="list-group">
            <li v-for="task in tasks" :key="task.id" class="list-group-item list-group-item-action"
              :class="{ active: selectedTask?.id === task.id }" @click="selectTask(task)">
              {{ task.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- RIGHT PANEL -->
    <div class="col-md-8">
      <div class="ibox mt-2">
        <div class="ibox-title bg-light py-2">
          <h5 class="mb-0">
            {{ selectedTask ? selectedTask.name : "Select a Task" }}
          </h5>
        </div>

        <div class="ibox-content p-3" v-if="selectedTask">
          <table class="table table-bordered align-middle">
            <thead class="table-light">
              <tr>
                <th class="text-center" style="width: 5%">#</th>
                <th style="width: 40%">Question</th>
                <th style="width: 20%">Response</th>
                <th style="width: 35%">Comment</th>
                <!-- <th style="width: 35%">Status</th> -->
                <th class="text-center" style="width: 10%" v-if="roleprivileges.includes('CRA Task Management Task Update')">Action</th>
                 <th class="text-center" style="width: 10%">Issue</th>

              </tr>
            </thead>

            <tbody>
              <tr v-for="(q, index) in selectedTask.questions" :key="q.id">
                <td>{{ index + 1 }}</td>
                <td class="text-wrap">{{ q.text }}</td>
                <td>
                  <div class="d-flex gap-2">
                    <label>
                      <input type="radio" value="Yes" v-model="q.answer" /> Yes
                    </label>
                    <label>
                      <input type="radio" value="No" v-model="q.answer" /> No
                    </label>
                    <label>
                      <input type="radio" value="N/A" v-model="q.answer" /> N/A
                    </label>
                  </div>
                </td>
                <td>
                  <textarea class="form-control" v-model="q.comment" placeholder="Enter comment"/>
                </td>
                <!-- <td>
                  <select class="form-control" v-model="q.status" :disabled="!roleprivileges.includes('CRA Task Management Task Update')">
                    <option value="">Select</option>
                    <option value="Pending">Pending</option>
                    <option value="Completed">Completed</option>
                    <option value="Rejected">Rejected</option>
                  </select>
                </td> -->
                <!-- PER QUESTION SAVE -->
                <td class="text-center" v-if="roleprivileges.includes('CRA Task Management Task Update')">
                  <button class="save_btn py-1 px-4" type="button" @click="saveQuestion(q)">
                    Save
                  </button>
                </td>
                  <td class="text-center">
                    <div class="position-relative">
                    <img
                      class="cursor-pointer"
                      src="../../assets/img/Raise_Issue.png"
                      alt="Create study"
                      style="width: 20px; height: 18px"
                      @click.prevent="OpenIssue(q)"
                    />
                    <div class="tool-tip">
                      {{ $t("navigations.raise issue") }}
                    </div>
                    </div>
                  </td>

              </tr>
            </tbody>
          </table>
          <div class="d-flex justify-content-end mt-3" v-if="roleprivileges.includes('CRA Task Management Task Update')">
            <button class="save_btn py-1 px-3" type="button" @click="saveAllQuestions">
              Save All
            </button>
          </div>
        </div>

        <div class="ibox-content text-center text-muted" v-else>
          Please select a task from the left panel
        </div>
      </div>
    </div>
  </div>
<createCraIssue
  v-if="showcreateIssueModal"
  :studyId="selectedStudyId"
  :cravisitName="visitname"
  :crasiteCode="sitecode"
  :crasiteId="siteid"
  @close="showcreateIssueModal = false"
/>

</template>
<script src="./CraTaskManagement.js"></script>
<style scoped>
.list-group-item {
  position: relative !important;
  cursor: pointer;
}

.list-group-item.active {
  position: relative !important;
  z-index: 1;
  background-color: #f1f3f5 !important; /* light grey */
  border-color: #e0e0e0 !important;
  color: #202325 !important; /* normal text color */
}

.ibox-content {
  overflow: auto !important;
}
.task-page-header {
  position: relative;
  width: 100%;
  height: 30px;
}

.tooltip-wrapper {
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
  z-index: 9999;
}

.close-icon {
  font-size: 18px;
  color: #555;
}

.close-icon:hover {
  color: #000;
}

/* Tooltip */
.custom-tooltip {
  position: absolute;
  top: 22px;
  right: 0;
  background: #000;
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
}

.tooltip-wrapper:hover .custom-tooltip {
  opacity: 1;
  visibility: visible;
}

</style>
